import { Link } from 'react-router-dom';
import { CenteredLoader, Page, Section, Typography } from 'ui';

import { SiteMaterialUpdateForm } from '~/site-materials/components/SiteMaterialUpdateForm/SiteMaterialUpdateForm';

import { useGetSiteMaterialDetails } from '../../hooks/useGetSiteMaterialDetails/useGetSiteMaterialDetails';

export const SiteMaterialUpdate = () => {
  const { id, data, isLoading } = useGetSiteMaterialDetails();

  if (isLoading) {
    return <CenteredLoader />;
  }

  return (
    <Page>
      <Page.BackButton
        component={Link}
        to={`/ground-control/v2/manage-company/${data?.site.trade_company.id}/site-materials`}
      >
        Back to {data?.site.trade_company.name} site materials
      </Page.BackButton>
      {!data ? (
        <Typography variant="h4" gutterBottom>
          Site material not found
        </Typography>
      ) : (
        <Section title="Update site material">
          <SiteMaterialUpdateForm siteMaterialId={id} siteMaterialDetails={data} />
        </Section>
      )}
    </Page>
  );
};
